module.exports = __webpack_public_path__ + "img/P150T_weapon_16.47d4638a.png";